import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { UncontrolledDropdown, DropdownItem, DropdownToggle, DropdownMenu, Button } from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { Auth } from "aws-amplify";
import CustomSignOut from "../../components/CustomAmplifyComponents/CustomSignOut";
import CustomPasswordChange from "../../components/CustomAmplifyComponents/CustomPasswordChange";
import CreateQR from "./CreateQR";
import IntlMessages from "../../helpers/IntlMessages";
import { setContainerClassnames, clickOnMobileMenu } from "../../redux/menu/actions";
import { logoutUser, updateAuthState } from "../../redux/auth/actions";
import { changeLocale, getGroupNames } from "../../redux/settings/actions";
import { changeLanguageForRequestItems, setIsTranslationNeeded, createRequestQrImage } from "../../redux/request/actions";
import { changeLanguageForBookingItems } from "../../redux/booking/actions";
import { AWAITING_APPROVAL } from "../../constants/bookingStatusEnum";
import { menuHiddenBreakpoint, searchPath, localeOptions } from "../../constants/defaultValues";
import { MobileMenuIcon, MenuIcon } from "../../components/svg";
import Dictionary from "../../lang/entries/Dictionary";
import AppLocale from "../../lang/index";
import { getDirection, setDirection } from "../../helpers/Utils";

let openCount = 0;
let openRequestNotificationsArr = [];
let awaitingBookingNotificationsArr = [];
let openRequestAndAwaitingBookingNotificationsArr = [];

class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInFullScreen: false,
      searchKeyword: "",
      modal: false,
      modalAlert: false,
      password: "",
      oldPassword: "",
      isChanging: false,
      confirmPassword: "",
      error: false,
      isConfirmed: false,
      modalTesseract: false,
      modalQR: false,
      phoneNumber: "",
      email: "",
      errors: {
        firstName: "required",
        lastName: "required",
        phoneNumber: "required",
        email: "required",
        checkIn: "required",
        checkOut: "required",
        roomNo: "required"
      },
      valid: false,
      pmsQr: false,
      linkQr: false,
    };
  }

  componentDidMount() {
    this.props.getGroupNames();
  }

  componentWillReceiveProps({ allRequestItems, allBookingItems }) {
    openCount = 0;
    awaitingBookingNotificationsArr = [];
    openRequestNotificationsArr = [];
    openRequestAndAwaitingBookingNotificationsArr = [];
    if (allBookingItems && Object.values(allBookingItems) && Object.values(allBookingItems).length) {
      Object.values(allBookingItems).forEach(booking => {
        const bookingId = booking.id;
        if (booking && booking.status === AWAITING_APPROVAL && booking.created_at === booking.updated_at) {
          const awaitingBookingNotification = {
            iClassName: "iconsminds-id-card",
            clickAction: `/app/staff/bookings/${bookingId}`,
            title: booking.fullName,
            date: booking.updated_at_date,
            updatedAt: booking.updated_at,
            id: booking.id
          };
          awaitingBookingNotificationsArr = awaitingBookingNotificationsArr.concat(awaitingBookingNotification);
        }
      });
    }
    if (allRequestItems && Object.values(allRequestItems) && Object.values(allRequestItems).length) {
      Object.values(allRequestItems).forEach(request => {
        const requestId = request.id;
        if (request && request.status === "OPEN") {
          const openRequestNotification = {
            iClassName: "iconsminds-check",
            clickAction: `/app/staff/requests/${requestId}`,
            title: request.serviceName,
            date: request.updated_at_date,
            updatedAt: request.updated_at,
            id: requestId
          };
          openRequestNotificationsArr = openRequestNotificationsArr.concat(openRequestNotification);
          openCount++;
        }
      });
    }

    openRequestAndAwaitingBookingNotificationsArr = [...openRequestNotificationsArr, ...awaitingBookingNotificationsArr];
    openRequestAndAwaitingBookingNotificationsArr = openRequestAndAwaitingBookingNotificationsArr.sort((a, b) => {
      if (parseInt(a.updatedAt, 10) > parseInt(b.updatedAt, 10)) return -1;
      if (parseInt(a.updatedAt, 10) < parseInt(b.updatedAt, 10)) return 1;
      return 0;
    });
    this.changeTitle(openCount);
  }

  toggleTesseract = () => {
    this.setState(prevState => ({
      modalTesseract: !prevState.modalTesseract
    }));
  };

  handleChangeClickQR = async event => {
    event.preventDefault();
    const { hotelId, awsCognitoUserPoolId, hotelConfig, createRequestQrImage } = this.props;
    const hotel_id = hotelId;
    const user_pool_id = awsCognitoUserPoolId;
    const { googleCloudApiKey, webeePassDomainUrl, andorid_bundle_id, ios_bundle_id, app_store_id } = hotelConfig;
    const { firstName, lastName, email, phoneNumber: phone_number, checkIn, checkOut, roomNo } = this.state;

    try {
      this.setState({ isConfirmed: true });
      createRequestQrImage({
        hotel_id,
        phone_number,
        user_pool_id,
        firstName,
        lastName,
        email,
        checkIn,
        checkOut,
        roomNo,
        andorid_bundle_id,
        ios_bundle_id,
        app_store_id,
        googleCloudApiKey,
        webeePassDomainUrl,
        source: "scan"
      });
    } catch (e) {
      this.setState({ isConfirmed: false });
    }
  };

  handleChangeClick = async event => {
    event.preventDefault();
    const { oldPassword, password } = this.state;

    this.setState({ isChanging: true });
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(currentUser, oldPassword, password);
      this.setState({
        modalAlert: true,
        password: "",
        oldPassword: "",
        confirmPassword: ""
      });
    } catch (e) {
      this.setState({ isChanging: false, error: true });
    }
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleChangeQR = event => {
    event.preventDefault();
    const { errors } = this.state;
    switch (event.target.id) {
      case "phoneNumber":
        errors.phoneNumber =
          event.target.value.length > 0 && event.target.value.match(/^\+\*?(\d{1,2}|\d{1,3}|\d{1,4})(\d{7,14})$/i) ? "" : "form.valid.mobile";
        break;
      case "email":
        errors.email = event.target.value.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(event.target.value) ? "" : "form.valid.email";
        break;
      case "firstName":
        errors.firstName =
          event.target.value.length > 0 &&
            /^[A-Za-zÇçĞğİıÖöŞşÜü\s.\u0600-\u06FF\u0750-\u077F\uFB50-\uFDFF\uFE70-\uFEFF\u0400-\u04FF]+$/gu.test(event.target.value)
            ? ""
            : "form.valid.firstname";
        break;
      case "lastName":
        errors.lastName =
          event.target.value.length > 0 &&
            /^[A-Za-zÇçĞğİıÖöŞşÜü\s.\u0600-\u06FF\u0750-\u077F\uFB50-\uFDFF\uFE70-\uFEFF\u0400-\u04FF]+$/gu.test(event.target.value)
            ? ""
            : "form.valid.lastname";
        break;
      case "checkIn":
        errors.checkIn = event.target.value.length > 0 ? "" : "form.valid.checkIn";
        break;
      case "checkOut":
        errors.checkOut = event.target.value.length > 0 ? "" : "form.valid.checkOut";
        break;
      case "roomNo":
        errors.roomNo =
          event.target.value.length > 0 && /^[A-Za-z0-9ÇçĞğİıÖöŞşÜü\s]*[A-Za-z0-9ÇçĞğİıÖöŞşÜü][A-Za-z0-9ÇçĞğİıÖöŞşÜü\s]*$/u.test(event.target.value)
            ? ""
            : "form.valid.roomnumber";
        break;
      default:
        break;
    }
    this.setState({
      errors,
      [event.target.id]: event.target.value
    });

    if (
      errors.firstName.length === 0 &&
      errors.lastName.length === 0 &&
      (errors.phoneNumber.length === 0 || errors.email.length === 0) &&
      errors.checkIn.length === 0 &&
      errors.checkOut.length === 0 &&
      errors.roomNo.length === 0
    ) {
      this.setState({
        valid: true
      });
    } else {
      this.setState({
        valid: false
      });
    }
  };

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
      modalAlert: false,
      password: "",
      oldPassword: "",
      isChanging: false,
      confirmPassword: "",
      error: false
    }));
  };

  togglePmsQR = () => {
    this.setState(prevState => ({
      modalQR: !prevState.modalQR,
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      checkIn: "",
      checkOut: "",
      roomNo: "",
      errors: {
        firstName: "required",
        lastName: "required",
        phoneNumber: "required",
        email: "required",
        checkIn: "required",
        checkOut: "required",
        roomNo: "required"
      },
      valid: false,
      isConfirmed: false,
      pmsQr: true,
      linkQr: false
    }));
  };

  toggleQR = () => {
    this.setState(prevState => ({
      modalQR: !prevState.modalQR,
      phoneNumber: "",
      email: "",
      errors: {
        firstName: "required",
        lastName: "required",
        phoneNumber: "required",
        email: "required",
        checkIn: "required",
        checkOut: "required",
        roomNo: "required"
      },
      valid: false,
      isConfirmed: false,
      pmsQr: false,
      linkQr: true
    }));
  };

  changeTitle = count => {
    let newTitle = null;
    if (count > 0) {
      newTitle = `(${count}) on Zone`;
      newTitle = `(${count}) Staff App`;
    } else {
      newTitle = "on Zone";
      newTitle = "Staff App";
    }
    if (typeof document !== "undefined") {
      document.title = newTitle;
    }
  };

  handleChangeLocale = (locale, direction) => {
    const {
      changeLocale,
      setIsTranslationNeeded,
      changeLanguageForRequestItems,
      changeLanguageForBookingItems,
      timeZone,
      hotelConfig,
    } = this.props;

    changeLocale(locale);
    setIsTranslationNeeded(false);
    changeLanguageForRequestItems({ locale, timeZone });
    changeLanguageForBookingItems({ locale, timeZone });

    AppLocale[locale] = Dictionary(locale);
    if (hotelConfig.dictionary) {
      AppLocale[locale] = Dictionary(locale, hotelConfig.dictionary);
    }

    const currentDirection = getDirection().direction;
    if (direction !== currentDirection) {
      setDirection(direction);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  isInFullScreen = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };

  handleSearchIconClick = e => {
    if (window.innerWidth < menuHiddenBreakpoint) {
      let elem = e.target;
      if (!e.target.classList.contains("search")) {
        if (e.target.parentElement.classList.contains("search")) {
          elem = e.target.parentElement;
        } else if (e.target.parentElement.parentElement.classList.contains("search")) {
          elem = e.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains("mobile-view")) {
        this.search();
        elem.classList.remove("mobile-view");
        this.removeEventsSearch();
      } else {
        elem.classList.add("mobile-view");
        this.addEventsSearch();
      }
    } else {
      this.search();
    }
  };

  addEventsSearch = () => {
    document.addEventListener("click", this.handleDocumentClickSearch, true);
  };

  removeEventsSearch = () => {
    document.removeEventListener("click", this.handleDocumentClickSearch, true);
  };

  handleDocumentClickSearch = e => {
    let isSearchClick = false;
    if (e.target && e.target.classList && (e.target.classList.contains("navbar") || e.target.classList.contains("simple-icon-magnifier"))) {
      isSearchClick = true;
      if (e.target.classList.contains("simple-icon-magnifier")) {
        this.search();
      }
    } else if (e.target.parentElement && e.target.parentElement.classList && e.target.parentElement.classList.contains("search")) {
      isSearchClick = true;
    }

    if (!isSearchClick) {
      const input = document.querySelector(".mobile-view");
      if (input && input.classList) input.classList.remove("mobile-view");
      this.removeEventsSearch();
      this.setState({
        searchKeyword: ""
      });
    }
  };

  handleSearchInputChange = e => {
    this.setState({
      searchKeyword: e.target.value
    });
  };

  handleSearchInputKeyPress = e => {
    if (e.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    const { history } = this.props;
    history.push(`${searchPath}/${this.state.searchKeyword}`);
    this.setState({
      searchKeyword: ""
    });
  };

  toggleFullScreen = () => {
    const isInFullScreen = this.isInFullScreen();

    const docElm = document.documentElement;
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    this.setState({
      isInFullScreen: !isInFullScreen
    });
  };

  handleLogout = () => {
    const { history, logoutUser } = this.props;
    logoutUser(history);
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    e.preventDefault();
    const { setContainerClassnames, selectedMenuHasSubItems } = this.props;

    setTimeout(() => {
      const event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    setContainerClassnames(++menuClickCount, containerClassnames, selectedMenuHasSubItems);
  };

  mobileMenuButtonClick = (e, containerClassnames) => {
    e.preventDefault();
    const { clickOnMobileMenu } = this.props;
    clickOnMobileMenu(containerClassnames);
  };

  render() {
    const {
      containerClassnames, menuClickCount, locale, profile, hotelName, groupNames, isArDisabled,
      createQrForPms, createQR, auth, updateAuthState
    } = this.props;
    const {
      password, oldPassword, isChanging, confirmPassword, modalAlert, error, modal, isConfirmed, errors,
      valid, modalQR, firstName, lastName, phoneNumber, email, checkIn, checkOut, roomNo, pmsQr, linkQr
    } = this.state;

    let filteredGroupName;

    if (groupNames && groupNames.length > 0 && hotelName) {
      filteredGroupName = groupNames.filter(
        item => item !== null && item.staff_settings.staff_base_urlv2 !== null && !(item.staff_settings.hotel_name === hotelName)
      );
      filteredGroupName = filteredGroupName.sort((a, b) => a.staff_settings.hotel_name.localeCompare(b.staff_settings.hotel_name));
    }
    const filteredLocaleOptions = isArDisabled ? localeOptions.slice(0, -1) : localeOptions;
    return (
      <nav className="navbar fixed-top">
        <div className="d-flex align-items-center navbar-left">
          <NavLink to="#" className="menu-button d-none d-md-block" onClick={e => this.menuButtonClick(e, menuClickCount, containerClassnames)}>
            <MenuIcon />
          </NavLink>
          <NavLink
            to="#"
            className="menu-button-mobile d-xs-block d-sm-block d-md-none"
            onClick={e => this.mobileMenuButtonClick(e, containerClassnames)}
          >
            <MobileMenuIcon />
          </NavLink>
          <div className="user d-inline-block">
            <i className="name mr-1 iconsminds-hotel" style={{ fontSize: "20px" }} />
            <span className="name mr-1">{hotelName ? `${hotelName}` : ""}</span>
          </div>
          <div className="d-inline-block">
            <UncontrolledDropdown className="ml-2">
              <DropdownToggle caret color="light" size="sm" className="language-button">
                <span className="name">{locale.toUpperCase()}</span>
              </DropdownToggle>
              <DropdownMenu className="mt-3" right>
                {filteredLocaleOptions.map(l => {
                  return (
                    <DropdownItem onClick={() => this.handleChangeLocale(l.id, l.direction)} key={l.id}>
                      {l.name}
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>

        <NavLink to="/" className="navbar-logo">
          <span className="logo d-none d-xs-block" />
          <span className="logo-mobile d-block d-xs-none" />
        </NavLink>

        <div className="navbar-right">
          {createQrForPms && createQrForPms !== false ? (
            <div className="header-icons d-inline-block">
              <Button onClick={this.togglePmsQR} type="button" className="btn outline-light flex-grow-1 " color="outline-success" size="xs">
                <i className="iconsminds-qr-code" style={{ fontSize: "15px" }} />
                <span className="simple-icon-size d-none d-sm-inline-block">
                  <IntlMessages id="request.create_qr_pms" />
                </span>
              </Button>
            </div>
          ) : (
            ""
          )}
          {createQR && createQR !== false && (
            <div className="header-icons d-inline-block">
              <Button onClick={this.toggleQR} type="button" className="btn outline-light flex-grow-1 " color="outline-success" size="xs">
                + <i className="iconsminds-qr-code" style={{ fontSize: "15px" }} />
                <span className="simple-icon-size d-none d-sm-inline-block">
                  <IntlMessages id="request.create_qr" />
                </span>
              </Button>
            </div>
          )}

          <div className="user d-inline-block">
            <UncontrolledDropdown className="dropdown-menu-right">
              <DropdownToggle className="p-0" color="empty">
                <span className="name mr-1">{profile && profile.name ? `${profile.name} ${profile.family_name}` : ""}</span>
                <span>
                  <img alt="Profile" src="/assets/img/profile-default.jpeg" />
                </span>
              </DropdownToggle>
              <DropdownMenu className="mt-3" right>
                <div className="d-flex flex-row mb-3 pb-3 border-bottom">
                  <div className="pl-3 pr-2">
                    <p className="font-weight-medium mb-1">{profile && profile.name ? `${profile.name} ${profile.family_name}` : ""}</p>
                    <div className="d-inline-block">
                      <div className="badge badge-light" style={{ fontSize: "12px" }}>
                        <i className="iconsminds-hotel" />
                        {hotelName ? `${hotelName}` : ""}
                      </div>
                    </div>
                  </div>
                </div>
                <DropdownItem onClick={this.toggle}>
                  <IntlMessages id="user.changePassword" />
                </DropdownItem>
                <div className="d-flex flex-row mb-1 pb-1 border-bottom">
                  <CustomSignOut
                    authState={auth.authState}
                    authData={auth.authData}
                    updateAuthState={updateAuthState}
                  />
                </div>
                <div>
                  {filteredGroupName &&
                    filteredGroupName.length > 0 &&
                    filteredGroupName.map((hotels, index) => (
                      <a key={index} href={hotels.staff_settings.staff_base_urlv2}>
                        <div className="d-inline-block mt-2 w-100">
                          <div className="badge badge-gray " style={{ fontSize: "12px" }}>
                            <i className="iconsminds-hotel" />
                            {hotels.staff_settings.hotel_name}
                          </div>
                        </div>
                      </a>
                    ))}
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <CustomPasswordChange
            password={password}
            oldPassword={oldPassword}
            isChanging={isChanging}
            confirmPassword={confirmPassword}
            modalAlert={modalAlert}
            error={error}
            toggle={this.toggle}
            handleChangeClick={this.handleChangeClick}
            handleChange={this.handleChange}
            modal={modal}
            authState={auth.authState}
            authData={auth.authData}
            updateAuthState={updateAuthState}
          />
          <CreateQR
            togglePmsQR={this.togglePmsQR}
            toggleQR={this.toggleQR}
            handleChangeClickQR={this.handleChangeClickQR}
            handleChangeQR={this.handleChangeQR}
            isConfirmed={isConfirmed}
            errors={errors}
            valid={valid}
            modalQR={modalQR}
            firstName={firstName}
            lastName={lastName}
            phoneNumber={phoneNumber}
            email={email}
            checkIn={checkIn}
            checkOut={checkOut}
            roomNo={roomNo}
            pmsQr={pmsQr}
            linkQr={linkQr}
          />
        </div>
      </nav>
    );
  }
}

const mapStateToProps = ({ menu, settings, auth, requestApp, bookingApp }) => {
  const { allRequestItems } = requestApp;
  const { allBookingItems } = bookingApp;
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  const { locale, hotelConfig, groupNames } = settings;
  const { timeZone, hotelName, createQR, createQrForPms, hotelId, awsCognitoUserPoolId, isArDisabled } = settings.hotelConfig;
  const { profile } = auth;
  return {
    allRequestItems,
    allBookingItems,
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    locale,
    hotelConfig,
    timeZone,
    createQR,
    createQrForPms,
    profile,
    auth,
    hotelName,
    hotelId,
    awsCognitoUserPoolId,
    groupNames,
    isArDisabled
  };
};

const mapActionsToProps = {
  setContainerClassnames,
  clickOnMobileMenu,
  logoutUser,
  changeLocale,
  changeLanguageForRequestItems,
  changeLanguageForBookingItems,
  updateAuthState,
  setIsTranslationNeeded,
  createRequestQrImage,
  getGroupNames
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(TopNav)
);
